import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 31"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentcolor",
      "fill-rule": "evenodd",
      d: "M12.241 10.814c1.254 0 2.27.661 2.27 2.06 0 1.398-1.016 3.005-2.27 3.005s-2.27-1.607-2.27-3.005c0-1.399 1.016-2.06 2.27-2.06M17.76 10c1.254 0 2.27.66 2.27 2.06 0 1.398-1.016 3.005-2.27 3.005s-2.27-1.607-2.27-3.006S16.504 10 17.758 10m-1.94 5.272h3.88c1.265 0 2.301 1.01 2.301 2.243v1.67h-5.074v-.946c0-.711-.298-1.358-.778-1.826a2.68 2.68 0 0 0-1.627-.747c.37-.248.818-.394 1.298-.394m-5.517.815h3.879c1.266 0 2.302 1.009 2.302 2.242V20H8v-1.67c0-1.234 1.036-2.243 2.302-2.243"
    }, null, -1)
  ]))]))
}
export default { render: render }